import history from 'history/createBrowserHistory';

export default history({
    basename: '#',
});



// WEBPACK FOOTER //
// ./src/history.js